import styled from "styled-components";
import { Button as BsButton, Card as BsCard } from "react-bootstrap";

export const Wrapper = styled.div``;
export const StartButton = styled(BsButton)`
  && {
    width: 100%;
    background: #f59e0b;
    border-color: #f59e0b;
    font-weight: 700;
    border-radius: 8px;
    border-style: none;
    padding: 10px 20px;
  }
  &&:hover, &&:focus {
    filter: brightness(0.95);
    background: #f59e0b;
    border-color: #f59e0b;
  }
`;

export const Cover = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
  display: block;
`;

export const Section = styled(BsCard)`
  && { border: 0; border-radius: 12px; box-shadow: 0 10px 18px rgba(0,0,0,.06); background: #fff; }
  .body { padding: 16px; }
`;

export const SidebarCard = styled(BsCard)`
  && {
    border-radius: 12px;
    background: #fff;
    border: 0;
    box-shadow: 0 10px 18px rgba(0,0,0,.06);

    max-height: calc(100vh - 160px);
    display: flex;
    flex-direction: column;
  }

  .sidebar-header {
    font-weight: 700;
    padding: 16px 16px 8px 16px;
    flex: 0 0 auto; 
  }
`;

export const LessonList = styled.div`
  flex: 1 1 auto; 
  overflow-y: auto; 
  padding: 0 16px 12px 16px;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 3px;
  }
`;

export const LessonItem = styled.div`
  padding: 12px 0;
  border-bottom: 1px solid #e5e7eb;

  .title {
    font-size: 14px;
    font-weight: 700;
    color: #1f2937;
    margin-bottom: 6px;
    line-height: 1.2;
  }
  .subline {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: #6b7280;
  }
`;

export const PlayBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 4px;
  background: #f59e0b;
  color: #fff;
  font-size: 8px; 
`;

export const Sticky = styled.div`
  position: sticky;
  top: 84px;
`;

export const LayoutGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-template-areas:
    "cover   sidebar"
    "desc    sidebar";
  gap: 24px;
  align-items: start;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    grid-template-areas:
      "cover"
      "start"
      "lessons"
      "desc";
  }
`;

export const CoverArea = styled.div`
  grid-area: cover;
`;

export const SidebarWrapper = styled.div`
  grid-area: sidebar;
  position: sticky;
  top: 84px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: 767px) {
    display: contents;
  }
`;

export const StartArea = styled.div`
  grid-area: start;
`;

export const DescArea = styled.div`
  grid-area: desc;
`;

export const LessonsArea = styled.div`
  grid-area: lessons;
`;


export const LessonPageOuter = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 24px;

  @media (max-width: 767px) {
    flex-direction: column;
    gap: 0;
  }
`;

export const LessonMainColumn = styled.div`
  flex: 1;
  max-width: calc(100% - 416px);
  padding-right: 24px;

  @media (max-width: 767px) {
    max-width: 100%;
    padding-right: 0;
  }
`;

export const LessonSidebarColumn = styled.div`
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: fixed;
  width: 392px;
  height: calc(100vh - 80px);
  top: 80px;
  right: 0px;
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  z-index: 1000;
  overflow: hidden;

  @media (max-width: 767px) {
    position: static;
    width: 100%;
    height: auto;
    padding: 0;
    box-shadow: none;
    background: transparent;
    overflow: visible;
    margin-top: 4px;

    .text-center {
      margin-bottom: 8px !important;
    }
    .text-center > .d-flex {
      margin-bottom: 4px !important;
    }
  }
`;

export const SidebarProgressSection = styled.div`
  @media (max-width: 767px) {
    display: none;
  }
`;

export const SidebarDivider = styled.div`
  height: 1px;
  background-color: #dee2e6;
  margin: 0 -24px;
  margin-bottom: 16px;

  @media (max-width: 767px) {
    display: none;
  }
`;

export const SidebarLessonList = styled.div`
  flex: 1 1 auto;
  overflow-y: auto;
  max-height: calc(100vh - 350px);

  @media (max-width: 767px) {
    overflow-y: visible;
    max-height: none;
    flex: none;
  }
`;

export const MobileProgressSection = styled.div`
  display: none;

  @media (max-width: 767px) {
    display: block;
    margin-top: 12px;
    margin-bottom: 0;
  }
`;

export const LessonCompleteRow = styled.div`
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;

  @media (max-width: 767px) {
    > .btn,
    > button {
      width: 100%;
      min-width: unset !important;
    }
    > div {
      width: 100%;
      justify-content: center;
    }
  }
`;
